var validObj = {};

// 宽泛国际邮箱验证（推荐方案）
validObj.isValidEmail= function(email) {
    // 去除首尾空格
    const trimmed = email.trim();
    if (!trimmed) return false;
  
    // 宽泛正则：允许各国字符、加号、点号、子域名、长域名
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  
    // 基本结构检查
    if (!regex.test(trimmed)) return false;
  
    // 检查@符号数量（只能有一个）
    const parts = trimmed.split('@');
    if (parts.length !== 2) return false;
  
    const local = parts[0];
    const domain = parts[1];
  
    // 本地部分长度限制（1-64字符）
    if (local.length < 1 || local.length > 64) return false;
  
    // 域名部分长度限制（1-253字符）
    if (domain.length < 1 || domain.length > 253) return false;
  
    // 域名不能以点开头或结尾
    if (domain.startsWith('.') || domain.endsWith('.')) return false;
  
    // 不能有连续的点
    if (domain.includes('..')) return false;
  
    // 顶级域至少2个字符（支持新顶级域如 .travel、.shop 等）
    const tld = domain.split('.').pop();
    if (!tld || tld.length < 2) return false;
  
    // 检查是否包含非法字符（域名允许字母、数字、连字符和点）
    const domainClean = domain.replace(/[a-zA-Z0-9.-]/g, '');
    if (domainClean.length > 0) return false;
  
    return true;
  }


  export default validObj